import React from 'react';

export const Divider = ({ className = '', style = {} }) => (
    <div className={`dm-divider ${className}`} style={style} />
);
